import { cn } from "../../../utils/cn";
import Spinner from "../Spinner/Spinner";

export interface SectionLoaderProps {
  className?: string;
}

/**
 *
 */
export function SectionLoader({ className }: SectionLoaderProps) {
  const css = cn(
    className,
    "absolute inset-0 grid place-content-center z-index-50",
  );

  return (
    <div className={css}>
      <Spinner size="3.8rem" className="text-primary-500" />
    </div>
  );
}
